import { Link } from "react-router-dom";

export function TermsAcceptanceCheckbox({ checked, onChange, id = "accept-terms", testId = "register-terms-checkbox" }) {
    return (
        <label
            htmlFor={id}
            className="flex items-start gap-3 rounded-md border border-white/[0.08] bg-white/[0.02] px-3 py-3 cursor-pointer"
        >
            <input
                id={id}
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                required
                className="mt-0.5 h-4 w-4 shrink-0 rounded border-white/20 bg-[#1A1A1A] text-[#00BF0D] focus:ring-[#00BF0D]/30"
                data-testid={testId}
            />
            <span className="text-xs leading-relaxed text-white/60">
                I agree to the{" "}
                <Link
                    to="/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-[#00BF0D] hover:underline"
                    onClick={(e) => e.stopPropagation()}
                    data-testid={`${testId}-link`}
                >
                    Terms of Service
                </Link>
                {" "}and{" "}
                <Link
                    to="/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-[#00BF0D] hover:underline"
                    onClick={(e) => e.stopPropagation()}
                    data-testid={`${testId}-privacy-link`}
                >
                    Privacy Policy
                </Link>
                , including FairShare&apos;s platform fees on transactions and applicable third-party processing charges.
            </span>
        </label>
    );
}
